export const boxStyle = {
  p: { xs: 1, md: 2 },
  maxWidth: '100%',
};

export const stackStyle = {
  mb: 3,
  alignItems: { xs: "stretch", md: "center" },
  flexDirection: { xs: "column", md: "row" },
  gap: { xs: 2, md: 2 }
};

// Responsive minWidth for period filter select
export const formControlPeriodStyle = {
  minWidth: { xs: '100%', sm: 150, md: 180 },
  width: { xs: '100%', md: 'auto' },
  mb: { xs: 1, md: 0 }
};

export const formControlMonthStyle = {
  minWidth: { xs: '100%', sm: 100 },
  width: { xs: '100%', md: 'auto' },
  borderRadius: 2,
  bgcolor: "#f6f8fb",
  boxShadow: '0px 2px 8px rgba(0,0,0,0.04)',
  mb: { xs: 1, md: 0 }
};

export const formControlYearStyle = {
  minWidth: { xs: '100%', sm: 100 },
  width: { xs: '100%', md: 'auto' },
  borderRadius: 2,
  bgcolor: "#f6f8fb",
  boxShadow: '0px 2px 8px rgba(0,0,0,0.04)',
  mb: { xs: 1, md: 0 }
};

export const yearSelectSx = {
  fontWeight: 600
};

export const textFieldDayStyle = {
  minWidth: { xs: '100%', sm: 180 },
  width: { xs: '100%', md: 'auto' },
  mb: { xs: 1, md: 0 }
};

export const weekPickerBoxStyle = {
  height: 40,
  display: "flex",
  alignItems: "center",
  minWidth: { xs: '100%', md: 150 },
  width: { xs: '100%', md: 'auto' },
  mb: { xs: 1, md: 0 }
};

export const loadingBoxStyle = {
  py: 8,
  textAlign: 'center'
};

export const transitionProps = {
  initial: { opacity: 0, x: 24 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -24 },
  transition: { duration: 0.5, ease: 'easeInOut' }
};

export const staffListScrollable = {
  p: 0,
  maxHeight: { xs: '220px', md: '380px' }, 
  overflowY: 'auto',
  overflowX: 'hidden',
  pr: 1
};

// For the "No staff found" text
export const noStaffFoundText = {
  textAlign: "center",
  color: "#aaa",
  margin: "30px 0"
};

// For the staff history detail box
export const staffHistoryDetailBox = {
  pl: 2,
  pr: 2,
  pt: 1,
  pb: 1,
  maxWidth: '90%',
  margin: '0 auto 10px auto'
};

// For the open staff card (adds blue border and shadow)
export const openStaffCardSx = {
  mb: 2,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  maxWidth: '98%',
  boxShadow: '0px 4px 18px rgba(33,150,243,0.12)',
  border: '2px solid #1976d2',
};

// For the closed staff card (just margin and pointer)
export const closedStaffCardSx = {
  mb: 2,
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  maxWidth: '98%',
};